import React, { useState } from 'react';
import { Box, Paper, Typography, Card, CardContent, CardActions, Button, Radio, RadioGroup, FormControlLabel, LinearProgress } from '@mui/material';
import { HowToVote } from '@mui/icons-material';

const Voting: React.FC = () => {
  const [polls] = useState([
    { id: '1', title: 'Paint Common Areas', desc: 'Vote on color scheme', options: ['White', 'Grey', 'Blue'], votes: [3, 2, 1], hasVoted: false },
    { id: '2', title: 'New Gym Equipment', desc: 'Approve budget for equipment', options: ['Yes', 'No'], votes: [4, 2], hasVoted: true }
  ]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Voting</Typography>
      {polls.map(p => (
        <Card key={p.id} sx={{ mb: 2 }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <HowToVote color="primary" />
              <Typography variant="h6">{p.title}</Typography>
            </Box>
            <Typography color="text.secondary" sx={{ mb: 2 }}>{p.desc}</Typography>
            {p.hasVoted ? (
              p.options.map((opt, i) => {
                const total = p.votes.reduce((a, b) => a + b, 0);
                const pct = Math.round((p.votes[i] / total) * 100);
                return <Box key={i} sx={{ mb: 1 }}><Box sx={{ display: 'flex', justifyContent: 'space-between' }}><Typography>{opt}</Typography><Typography>{pct}%</Typography></Box><LinearProgress variant="determinate" value={pct} /></Box>;
              })
            ) : (
              <RadioGroup>{p.options.map((opt, i) => <FormControlLabel key={i} value={i.toString()} control={<Radio />} label={opt} />)}</RadioGroup>
            )}
          </CardContent>
          {!p.hasVoted && <CardActions><Button variant="contained">Vote</Button></CardActions>}
        </Card>
      ))}
    </Box>
  );
};
export default Voting;
